var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.138,
    height: 17.138,
    viewBox: "0 0 17.138 17.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.069,
    cy: 8.069,
    r: 8.069,
    transform: "translate(16.138 16.138) rotate(180)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-dropdown-1197614",
    transform: "translate(11.205 9.801) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5196",
    "data-name": "Path 5196",
    d: "M2.876,0a.15.15,0,0,0-.1.041L.046,2.641a.15.15,0,0,0,.207.217L2.876.357l2.67,2.549a.15.15,0,1,0,.207-.217L2.979.042A.15.15,0,0,0,2.876,0Z",
    transform: "translate(0.237 0.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5196_-_Outline",
    "data-name": "Path 5196 - Outline",
    d: "M3.113,0a.385.385,0,0,0-.267.107L.12,2.707a.387.387,0,0,0-.013.547.387.387,0,0,0,.547.013L3.113.922,5.619,3.315a.387.387,0,0,0,.535-.56L3.38.107A.386.386,0,0,0,3.113,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.06105ae4691843b30ca690f08f4b1b7e.svg";
export { ForwardRef as ReactComponent };